/** EXT token identifier encoding (Toniq / Entrepot). */
import { Principal } from "@dfinity/principal";
const BASE32_ALPHABET = "abcdefghijklmnopqrstuvwxyz234567";
export function base32NoPad(bytes) {
    let result = "";
    let bits = 0;
    let value = 0;
    for (let i = 0; i < bytes.length; i++) {
        value = (value << 8) | bytes[i];
        bits += 8;
        while (bits >= 5) {
            bits -= 5;
            result += BASE32_ALPHABET[(value >>> bits) & 0x1f];
        }
    }
    if (bits > 0) {
        result += BASE32_ALPHABET[(value << (5 - bits)) & 0x1f];
    }
    return result;
}
/** Sync EXT TokenIdentifier — use in thumb URL builders (no dynamic import). */
export function encodeExtTokenIdentifierSync(canisterId, tokenIndex) {
    const canisterBytes = Principal.fromText(canisterId).toUint8Array();
    const prefix = new Uint8Array([0x0a, 0x74, 0x69, 0x64]); // \x0Atid
    const indexBytes = new Uint8Array(4);
    new DataView(indexBytes.buffer).setUint32(0, tokenIndex, false);
    const data = new Uint8Array(prefix.length + canisterBytes.length + indexBytes.length);
    data.set(prefix, 0);
    data.set(canisterBytes, prefix.length);
    data.set(indexBytes, prefix.length + canisterBytes.length);
    return Principal.fromUint8Array(data).toText();
}
export async function encodeExtTokenIdentifier(canisterId, tokenIndex) {
    return encodeExtTokenIdentifierSync(canisterId, tokenIndex);
}
/** Entrepot escrow memo: prefix 69690000 + decimal token index (DGDG convention). */
export function entrepotPurchaseMemo(tokenIndex) {
    return BigInt(`69690000${tokenIndex}`);
}
export function subaccountBytes(index = 0) {
    const bytes = new Uint8Array(32);
    if (index > 0) {
        bytes[31] = index & 0xff;
    }
    return bytes;
}
/** Parse 64-char hex ICP account identifier to 32-byte blob for legacy ledger.transfer. */
export function accountIdHexToBytes(accountIdHex) {
    const hex = accountIdHex.trim().toLowerCase();
    if (!/^[0-9a-f]{64}$/.test(hex)) {
        throw new Error("Invalid ICP account identifier (expected 64 hex chars)");
    }
    const out = [];
    for (let i = 0; i < hex.length; i += 2) {
        out.push(Number.parseInt(hex.slice(i, i + 2), 16));
    }
    return out;
}
